<template>
  <div>
    <h2 class="step_heading">{{heading}}</h2>

    <div class="step_description">
      <slot name="description"/>
    </div>

    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StepContainer",
  props: {
    heading: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.step_heading {
  margin-bottom: 10px;
  font-size: 1.375rem;
  font-weight: bold;
}

.step_description {
  margin-bottom: 2rem;

  p {
    margin-bottom: 10px;
    line-height: 1.3;
  }
}
</style>
